var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-search search",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [(_vm.edituser_component == true) ? _c('a', {
    staticClass: "btn-setting d-sm-down-none",
    on: {
      "click": _vm.addNewUser
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]) : _vm._e()])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("User Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": " Enter User Name"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("User Email")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": " Enter User Name"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("User ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Enter User ID"
    },
    model: {
      value: (_vm.newuserid),
      callback: function($$v) {
        _vm.newuserid = $$v
      },
      expression: "newuserid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Old User ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Enter Old User ID"
    },
    model: {
      value: (_vm.olduserid),
      callback: function($$v) {
        _vm.olduserid = $$v
      },
      expression: "olduserid"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("User Mobile Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter User Mobile"
    },
    model: {
      value: (_vm.mobilenumber),
      callback: function($$v) {
        _vm.mobilenumber = $$v
      },
      expression: "mobilenumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("User Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.utype),
      expression: "utype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "utype",
      "id": "utype"
    },
    on: {
      "click": function($event) {
        _vm.selectUserType()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.utype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a User Type")]), _vm._v(" "), _vm._l((_vm.listUserTypeData), function(usertype_obj) {
    return _c('option', {
      domProps: {
        "value": usertype_obj.usertypeid
      }
    }, [_vm._v(_vm._s(usertype_obj.usertypename))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userstatus),
      expression: "userstatus",
      modifiers: {
        "string": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "userstatus",
      "id": "userstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("InActive")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.hubServiceCenterList,
      "name": "hubid",
      "id": "hubid",
      "placeholder": "Select Hub",
      "label": "label",
      "track-by": "label"
    },
    on: {
      "input": _vm.resetTrackRole
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.utype == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Client Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker'></i>"
    }
  }, [_c('Multiselect', {
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.clientsList,
      "name": "clientid",
      "id": "clientid",
      "placeholder": "Select Client",
      "label": "label",
      "track-by": "label"
    },
    model: {
      value: (_vm.clientid),
      callback: function($$v) {
        _vm.clientid = $$v
      },
      expression: "clientid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Track Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cogs'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trackname),
      expression: "trackname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "trackname",
      "id": "trackname"
    },
    on: {
      "click": function($event) {
        _vm.getRolesByTrack()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trackname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a Track")]), _vm._v(" "), _vm._l((_vm.listTrackData), function(role_obj) {
    return _c('option', {
      domProps: {
        "value": role_obj.id
      }
    }, [_vm._v(_vm._s(role_obj.label))])
  })], 2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.istrackloader
    },
    on: {
      "update:active": function($event) {
        _vm.istrackloader = $event
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.showRoles) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Role Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cogs'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rolename),
      expression: "rolename"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "rolename",
      "id": "rolename"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rolename = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select a Role")]), _vm._v(" "), _vm._l((_vm.listRolesData), function(role_obj) {
    return _c('option', {
      domProps: {
        "value": role_obj.roleid
      }
    }, [_vm._v(_vm._s(role_obj.rolename))])
  })], 2), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isRoleloader
    },
    on: {
      "update:active": function($event) {
        _vm.isRoleloader = $event
      }
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchUserData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('span', [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" User List\n          "), (_vm.usercount) ? _c('small', {
    staticStyle: {
      "float": "right",
      "color": "red"
    }
  }, [_vm._v("Total Users found : " + _vm._s(_vm.usercount))]) : _vm._e()])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listUserData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.userid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.username))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.email))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MobileNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.status == true) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (data.status == false) ? _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Inactive")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(_vm.edituser_component == true) ? _c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit User"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getUserRowData(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.overrideuseraccess_component == true) ? _c('i', {
      staticClass: "fa fa-cog text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Override Module Access"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getUserSettings(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.accessprojects_component == true) ? _c('i', {
      staticClass: "fa fa-universal-access text-successedit fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Application Access"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getUserAccessSettings(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.userclientmap_component == true) ? _c('i', {
      staticClass: "fa fa-users fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "User Client Mapping"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getUserClientMap(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.IsLoggedIn === true && _vm.IsLoggedIn_component == true) ? _c('i', {
      staticClass: "fa fa-desktop fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Desktop Forced Logout"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getforcedLogoutRowData(data.userid, 'dekstop')
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.IsMobileLoggedIn && _vm.IsMobileLoggedIn_component === true) ? _c('i', {
      staticClass: "fa  fa-mobile fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Mobile Forced Logout"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getforcedLogoutRowData(data.userid, 'mobile')
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.tripclose_component == true) ? _c('i', {
      staticClass: "fa fa-motorcycle fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Force trip close"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showTripCloseModal(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mappinguserhubs_component == true) ? _c('i', {
      staticClass: "fa fa-cubes fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Add or remove hubs"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.UpdateUserHubs(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), ((data.utype == 1 && _vm.isShowClientCredentials == true)) ? _c('i', {
      staticClass: "fa fa-info fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Display Client Data"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clientData(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.mappingsubdepartment_component == true) ? _c('i', {
      staticClass: "fa fa-slack fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Mapping Subdepartment"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.UpdateUserSubdepartment(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.ismobileverification_component == true && data.ismobileverified == true) ? _c('i', {
      staticClass: "fa fa-mobile fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Is Mobile Verification"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getMobileVerifiedData(data.userid)
        }
      }
    }) : _vm._e(), _vm._v(" "), ((data.utype == 2)) ? _c('i', {
      staticClass: "fa fa-user fa-lg mt-2 ml-2",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "web2faotp"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getMobileVerifiedLinkData1(data.userid, data.web2faotp)
        }
      }
    }) : _vm._e()])])
  })], 2)]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusUserModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to " + _vm._s(_vm.changestatus) + " this User?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.changeUserStatus, function($event) {
        _vm.modalShow = false
      }]
    }
  }, [_vm._v("Save changes")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusUserModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#forcedLogoutmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addforcedLogoutmodalShow = false
      }
    },
    model: {
      value: (_vm.forcedLogoutmodalShow),
      callback: function($$v) {
        _vm.forcedLogoutmodalShow = $$v
      },
      expression: "forcedLogoutmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeforcedLogoutModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to forced logout this User from " + _vm._s(this.logOutDevice) + " logged in application.?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.forcedLoggoutUser()
      }, function($event) {
        _vm.modalShow = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeforcedLogoutModal
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "id": "#confirmationmodal"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.modalclient),
      callback: function($$v) {
        _vm.modalclient = $$v
      },
      expression: "modalclient"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Client User Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeclientDataModal
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('p', [_c('a', {
    staticClass: "clienttitle"
  }, [_vm._v("Client Name")]), _vm._v(": " + _vm._s(_vm.clientUserData.clientname) + " ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('p', [_c('a', {
    staticClass: "clienttitle"
  }, [_vm._v("Client ID")]), _vm._v(" : " + _vm._s(_vm.clientUserData.clientid) + " ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "user_name"
    }
  }, [_c('b-form-fieldset', [_c('p', {
    staticClass: "model_para"
  }, [_c('a', {
    staticClass: "clienttitle"
  }, [_vm._v("UserName ")]), _vm._v(" : " + _vm._s(_vm.clientUserData.username) + " ")])])], 1), _vm._v(" "), ((_vm.clientUserData.password)) ? _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "password"
    }
  }, [_c('b-form-fieldset', [_c('p', {
    staticClass: "model_para"
  }, [_c('a', {
    staticClass: "clienttitle"
  }, [_vm._v("Password")]), _vm._v(" : " + _vm._s(_vm.clientUserData.password) + " ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.clientUserData.clientpassword)) ? _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "password"
    }
  }, [_c('b-form-fieldset', [_c('p', {
    staticClass: "model_para"
  }, [_c('a', {
    staticClass: "clienttitle"
  }, [_vm._v("Password")]), _vm._v(" : " + _vm._s(_vm.clientUserData.clientpassword) + " ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    attrs: {
      "id": "manifestsecretkey"
    }
  }, [_c('b-form-fieldset', [_c('p', {
    staticClass: "model_para"
  }, [_c('a', {
    staticClass: "clienttitle"
  }, [_vm._v("Secretkey")]), _vm._v(" : " + _vm._s(_vm.clientUserData.manifestsecretkey) + " ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-left": "-1.2em"
    },
    attrs: {
      "type": "button",
      "id": "checkBtn"
    },
    on: {
      "click": function($event) {
        _vm.checkClientAuth(_vm.clientUserData)
      }
    }
  }, [_vm._v("Check Client Authentication")])], 1), _vm._v(" "), (_vm.successMsg === 'Authentication Successful.') ? _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-left": "-1.2em"
    }
  }, [_c('div', {
    staticClass: "successMessage"
  }, [_vm._v("\n                        " + _vm._s(_vm.successMsg)), _c('i', {
    staticClass: "fa fa-window-close",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeSuccessMsg
    }
  })])]) : (_vm.successMsg === 'Authentication Failed.') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "failureMessage"
  }, [_vm._v("\n                          " + _vm._s(_vm.successMsg)), _c('i', {
    staticClass: "fa fa-window-close",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeSuccessMsg
    }
  })]), _vm._v(" "), (_vm.checklivestatus == true) ? _c('div', [_c('b-button', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-left": "-1.2em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setupClient(_vm.clientUserData.userid, _vm.clientUserData.clientid)
      }
    }
  }, [_vm._v("Click here to update password")])], 1) : _vm._e()]) : _vm._e()])])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#tripclosemodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.tripclosemodal = false
      }
    },
    model: {
      value: (_vm.tripclosemodal),
      callback: function($$v) {
        _vm.tripclosemodal = $$v
      },
      expression: "tripclosemodal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-window-close-o close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closemodal
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Choose trip track to close trip.")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.closeTrip($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Trip Track")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.triptrack),
      expression: "triptrack"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    class: {
      'form-control':
      true, 'error': _vm.errors.has('TripTrack')
    },
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "name": "TripTrack"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.triptrack = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Trip track")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FM"
    }
  }, [_vm._v("First Mile")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LM"
    }
  }, [_vm._v("Last Mile")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('TripTrack')),
      expression: "errors.has('TripTrack')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Trip Track.")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")]), _vm._v(" \n              "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closemodal
    }
  }, [_vm._v("Cancel")])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal1",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.mobileverificationmodalShow),
      callback: function($$v) {
        _vm.mobileverificationmodalShow = $$v
      },
      expression: "mobileverificationmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changeMobileVerificationStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusMobileVerificationModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Do you want to re verify mobile number of user?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save changes")]), _vm._v(" \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeStatusMobileVerificationModal
    }
  }, [_vm._v("Cancel")])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal3",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow1 = false
      }
    },
    model: {
      value: (_vm.web2faflagmodalShow),
      callback: function($$v) {
        _vm.web2faflagmodalShow = $$v
      },
      expression: "web2faflagmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.changeweb2faStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusweb2faflagModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.web2faflagmodalShowtruemsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save changes")]), _vm._v(" \n        "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeStatusweb2faflagModal
    }
  }, [_vm._v("Cancel")])])])])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("User Id")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("User Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("User Email")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Mobile Number")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3380aa86","hasScoped":true}!./src/views/components/user/user.component.html
// module id = 699
// module chunks = 1